class StorageHelper{
    
    localSave(key:any, value:any){
        localStorage.setItem(key, value)
    }
      
    localRead(key:any){
        return localStorage.getItem(key) || ''
     }
}

export const storageHelper = new StorageHelper()
